import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Typography, Paper, } from '@mui/material'
import { Checkbox } from 'antd'
import { ResponsiveContainer, Tooltip, BarChart, Bar, XAxis, YAxis } from 'recharts'

const metadata = {
  "smartwatch": {
    "alertSOS": { "color": "#66c2a5" },
    "alertFall": { "color": "#fc8d62" },
    "alertStill": { "color": "#8da0cb" },
    "alert_BodyTemp": { "color": "#e78ac3" },
    "alert_HeartRate": { "color": "#a6d854" },
    "alert_Geofencing": { "color": "#ffd92f" }
  },
  "proximity": {
    "proximity_danger_zone": { "color": "#007BFF" },
  },
  "ai_detection": {
    "ppe": { "color": "#29ABE2" },
    "falling": { "color": "#FED766" },
    "smoking": { "color": "#EF4136" },
    "danger_zone": { "color": "#e78ac3" },
    "fire": { "color": "#006C7A" }
  },
  "gas_detector": {
    "alert_o2_level1": { "color": "#26C6DA" },
    "alert_o2_level2": { "color": "#112E51" },
    "alert_co_level1": { "color": "#FF7043" },
    "alert_co_level2": { "color": "#78909C" },
    "alert_h2s_level1": { "color": "#2E78D2" },
    "alert_h2s_level2": { "color": "#006C7A" },
    "alert_ch4_level1": { "color": "#FFBEA9" },
    "alert_ch4_level2": { "color": "#97BCE9" },
    "alert_co2_level1": { "color": "#8da0cb" },
    "alert_co2_level2": { "color": "#ffd92f" },
  },
  "flood_sensor": {
    "alert_flooding": { "color": "#8da0cb" },
  },
  "smart_lock": {
    "alert_BatteryLevel": { "color": "#26C6DA" },
    "alert_LeverAlert": { "color": "#FF7043" },
    "alert_ShellAlert": { "color": "#2E78D2" },
    "alert_LeverCuttingAlert": { "color": "#FFBEA9" },
    "alert_SmartLockNoNorkingPermit": { "color": "#00BF0F" },
    "alert_SmartLockUnauthorizedAttempt": { "color": "#BEdF0F" },
  },
  "confined_space": {
    "alert_confinedSpaceNoNorkingPermit": { "color": "#0f792f" },
    "alert_confinedSpaceNoStandbyPerson": { "color": "#ff6f2f" }
  }
}

const ModuleGraph = ({ projectModules, alertTypes, alertEvents, module, data }) => {
  const { t } = useTranslation()
  const meta = metadata[module]

  const [show, setSow] = useState(Object.keys(meta))

  const handleChange = (value) => {
    setSow(value)
  }

  return (<>
    {(projectModules.includes(module)) && <>
      <Typography variant="h6" style={{ marginTop: "30px" }}><b>{t(alertTypes[module])}</b></Typography>
    
      <div style= {{ height: "400px", width: "100%" }}>
        <div style={{ display: "flex", width: "100%", height: "100%" }}>
          <div style={{ flexGrow: 1, height: "100%" }}>
            <ResponsiveContainer width="100%" height="100%">
              <BarChart
                width="100%" height="100%"
                data={data}
                maxBarSize={80}
                margin={{ top: 30, right: 30, left: 20, bottom: 20 }}
              >
                <XAxis dataKey="name" />
                <YAxis allowDecimals={false} />
                <Tooltip />

                <Bar dataKey="" stackId="a" strokeWidth={0} legendType="none" tooltipType="none" dot={false} activeDot={false} />

                {Object.entries(meta).map(([k, v]) => <>
                  {show.includes(k) &&
                    <Bar dataKey={k} stackId="a" name={t(alertEvents[module][k])} fill={v["color"]} />
                  }
                </>)}
              </BarChart>
            </ResponsiveContainer>
          </div>

          <div style={{ width: "250px", height: "100%", display: "flex", alignItems: "center" }}>
            <Paper elevation={3} style={{ padding: "20px", marginRight: "15px", width: "100%" }}>
              <Checkbox.Group style={{ display: "inline-block" }} value={show} onChange={handleChange}>
                {Object.entries(meta).map(([k, v]) =>
                  <div style={{ display: "flex", flexFlow: "row", alignItems: "center" }}>
                    <div style={{ height: "15px", width: "15px", backgroundColor: v["color"], marginRight: "5px" }} />
                    <div><Checkbox checked={show.includes(k) === true} value={k}>{t(alertEvents[module][k])}</Checkbox></div>
                  </div>
                )}
              </Checkbox.Group>
            </Paper>
          </div>
        </div>
      </div>
    </>}
  </>)
}

export default ModuleGraph
